// client/src/components/TiptapEditor/MenuBar/LinkGroup.js
import React, { useCallback } from "react";
import { Icon } from "semantic-ui-react";

export const LinkGroup = ({ editor }) => {
  // Usamos useCallback para que esta función no se recree en cada renderizado
  const setLink = useCallback(() => {
    // Obtenemos la URL actual si el texto seleccionado ya es un enlace
    const previousUrl = editor.getAttributes("link").href;

    // Pedimos al usuario la nueva URL, mostrando la anterior como valor por defecto
    const url = window.prompt("URL", previousUrl);

    // Si el usuario cancela, no hacemos nada
    if (url === null) {
      return;
    }

    // Si el usuario borra la URL y acepta, quitamos el enlace
    if (url === "") {
      editor.chain().focus().extendMarkRange("link").unsetLink().run();
      return;
    }

    // Si el usuario introduce una URL, creamos o actualizamos el enlace
    editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run();
  }, [editor]);

  if (!editor) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        onClick={setLink}
        className={editor.isActive("link") ? "is-active" : ""}
      >
        <Icon name="linkify" />
      </button>
      {/* Un botón adicional para quitar el enlace rápidamente */}
      <button
        onClick={() => editor.chain().focus().unsetLink().run()}
        disabled={!editor.isActive("link")}
      >
        <Icon name="unlink" />
      </button>
    </>
  );
};
